import { Prop, Vue } from 'vue-property-decorator';
import ElementConfiguration, { ClassMap, StyleMap } from '../configuration/ElementConfiguration';
import './timeout.scss';
import { evaluate } from "../expression";

export default abstract class ElementBase extends Vue {
    @Prop({ required: true })
    readonly elementPath!: string;
    @Prop({ required: true })
    readonly configuration!: ElementConfiguration;

    protected lastDataUpdate: Date | null = null;
    protected timeoutSeconds: number = 0x7fffffff;

    private currentDate: Date = new Date();
    private currentDateUpdateTask: any = null;

    private get timedOut(): boolean {
        this.currentDate;//update trigger
        return this.lastDataUpdate !== null && this.lastDataUpdate.getTime() + this.timeoutSeconds * 1000 < Date.now();
    }

    private get timeOutClasses(): ClassMap {
        return { 'timed-out': this.timedOut };
    }

    get mergedClass(): ClassMap {
        const classes =  Object.assign({}, this.defaultClass(), this.optionsGeneratedClass(), this.configuration.class ?? {}, this.timeOutClasses);
        return evaluate(classes, this.bindingsContext);
    }

    get mergedStyle(): StyleMap {
        const style = Object.assign({}, this.defaultStyle(), this.optionsGeneratedStyle(), this.configuration.style ?? {});
        return evaluate(style, this.bindingsContext);
    }

    enableTimeout(): void {
        this.currentDateUpdateTask = setInterval(() => this.currentDate = new Date(), 10000);
    }

    mounted(): Promise<void> {
        return Promise.resolve();
    }

    beforeDestroy(): void {
        if (this.currentDateUpdateTask) {
            clearInterval(this.currentDateUpdateTask);
        }
    }

    public onInformationPush(elementPath: string, json: string): void {
    }

    protected defaultClass(): ClassMap {
        return {};
    };

    protected defaultStyle(): StyleMap {
        return {};
    };

    protected optionsGeneratedClass(): ClassMap {
        return {};
    };

    protected optionsGeneratedStyle(): StyleMap {
        return {};
    };

    protected get bindingsContext(): any {
        const context = {};
        Object.defineProperty(context, 'class', { get: () => this.mergedClass });
        Object.defineProperty(context, 'style', { get: () => this.mergedStyle });
        return context;
    }
}